import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './pages/LoginPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { ContactsPage } from './pages/ContactsPage';
import { UsersPage } from './pages/UsersPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { GanttPage } from './pages/GanttPage';
import { TodosPage } from './pages/TodosPage';
import { PhotoDocumentationPage } from './pages/PhotoDocumentationPage';
import { AboutPage } from './pages/AboutPage';
import { PwaUpdatePrompt } from './components/PwaUpdatePrompt';

export function App() {
  return (
    <>
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/gantt" element={<GanttPage />} />
        <Route path="/todos" element={<TodosPage />} />
        <Route path="/photos" element={<PhotoDocumentationPage />} />
        <Route
          path="/settings/templates"
          element={
            <RequireAuth roles={['admin', 'project_manager']}>
              <TemplatesPage />
            </RequireAuth>
          }
        />
        <Route path="/settings/contacts" element={<ContactsPage />} />
        <Route
          path="/settings/users"
          element={
            <RequireAuth roles={['admin']}>
              <UsersPage />
            </RequireAuth>
          }
        />
        <Route
          path="/settings/audit"
          element={
            <RequireAuth roles={['admin']}>
              <AuditLogPage />
            </RequireAuth>
          }
        />
        <Route path="/about" element={<AboutPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/projects" replace />} />
    </Routes>
    <PwaUpdatePrompt />
    </>
  );
}
